export default {
  "common.operation.ok": "好的",
  "common.operation.add": "添加",
  "common.operation.new": "新增",
  "common.operation.edit": "编辑",
  "common.operation.view": "查看",
  "common.operation.copy": "复制",
  "common.operation.cancel": "取消",
  "common.operation.delete": "删除",
  "common.operation.deleteTips": "是否确认删除？",
  "common.operation.back": "返回",
  "common.operation.save": "保存",
  "common.operation.submit": "提交",
  "common.operation.processing": "进程中",
  "common.operation.completed": "已完成",
  "common.operation.creating": "生成中",
  "common.operation.created": "已生成",
  "common.operation.more": "更多",
  "common.operation.print": "打印",
  "common.operation.share": "分享",
  "common.operation.detail": "详情",
  "common.operation.import": "导入",
  "common.operation.export": "导出",
  "common.operation.search": "搜索",
  "common.operation.upload": "上传",
  "common.operation.option": "操作",
  "common.operation.download": "下载",
  "common.operation.request": "请求",
  "common.operation.operate": "操作",
  "common.operation.confirm": "确定",
  "common.operation.setting": "设置",
  "common.operation.generate": "生成",
  "common.operation.open": "开",
  "common.operation.close": "关",
  "common.operation.modify": "修改",
  "common.operation.reset": "重置",
  "common.form.input.tips": "请输入",
  "common.form.date.tips": "请选择",
  "common.form.select.tips": "请选择",
  "common.request.succeed": "成功",
  "common.request.failed": "失败，请稍后重试",
  "common.request.error": "请求出错，请稍后重试",
  "common.gender": "性别",
  "common.gender.male": "男",
  "common.gender.Male": "男性",
  "common.gender.female": "女",
  "common.gender.Female": "女性",
  "common.gender.unknown": "未知",
  "common.gender.Unknown": "未知",
  "common.user.name": "支持：中文，英文字母，空格",
  "common.user.account": "支持：字母，数字",
  "common.user.special.character": "不能输入特殊字符",
  "common.columns.name": "名称",
  "common.columns.creator": "创建者",
  "common.columns.age": "年龄",
  "common.columns.status": "状态",
  "common.columns.type": "类型",
  "common.columns.content": "内容",
  "common.columns.updateTime": "更新时间",
  "common.columns.starTime": "开始时间",
  "common.valueEnum.system": "系统",
  "common.valueEnum.custom": "自定义",
  "common.valueEnum.enable": "启用",
  "common.valueEnum.disable": "禁用",
  "common.step.next": "下一步",
  "common.step.prev": "上一步",
  "common.tips.noData": "暂无数据",
  "common.abnormality.normal": "正常",
  "common.abnormality.abnormal": "异常",
  "common.abnormality.low": "偏低",
  "common.abnormality.high": "偏高",
  "common.abnormality.negative": "阴性",
  "common.abnormality.positive": "阳性",
  "common.groupReport.referenceRange.min": "偏低",
  "common.groupReport.referenceRange.normal": "正常",
  "common.groupReport.referenceRange.high": "正常高值",
  "common.groupReport.referenceRange.max": "偏高",
  "common.groupReport.referenceRange.lean": "偏瘦",
  "common.groupReport.referenceRange.overweight": "超重",
  "common.groupReport.referenceRange.fat": "肥胖",
  "common.option.true": "是",
  "common.option.false": "否",
  "common.request.submit.success": '提交成功',
  "common.request.submit.loading": '正在提交',
  "common.request.submit.fail": '提交失败，请重试',
  "common.request.delete.success": '删除成功',
  "common.request.delete.loading": '正在删除',
  "common.request.delete.fail": '删除失败，请重试',
  "common.request.enable.success": '启用成功',
  "common.request.enable.loading": '正在启用',
  "common.request.enable.fail": '启用失败，请重试',
  "common.request.disable.success": '禁用成功',
  "common.request.disable.loading": '正在禁用',
  "common.request.disable.fail": '禁用失败，请重试',
  "common.time.early": "凌晨",
  "common.time.morning": "上午",
  "common.time.afternoon": "下午",
  "common.time.evening": "晚上",
  "common.timeUnit.year": "年",
  "common.timeUnit.month": "月",
  "common.timeUnit.day": "天",
  "common.timeUnit.hour": "小时",
  "common.timeUnit.minute": "分钟",
  "common.timeUnit.second": "秒",
  "common.timeUnit.Year": "年",
  "common.timeUnit.Month": "月",
  "common.timeUnit.Day": "天",
  "common.timeUnit.Hour": "时",
  "common.timeUnit.Minute": "分",
  "common.timeUnit.Second": "秒",
  "common.table.column.sort": "序号",
  "common.table.column.Sort": "序号",
}
